import {authenticatedUserPreferencesLoadable} from "../store/authenticatedUserStore";
import {DEFAULT_USER_PREFERENCES} from "../utils/userUtils";
import {UserPreferences} from "../types/domain/user";
import {useLoadableValueOrDefault} from "./jotaiHooks";

export const useUserPreferences = (): Required<UserPreferences> => {
    return useLoadableValueOrDefault(authenticatedUserPreferencesLoadable, DEFAULT_USER_PREFERENCES);
};
